import type { ClinicalTodayWorkFact, ClinicalTodayWorkView, ClinicalTodayStatus } from '@/dashboard/api';

export const TODAY_WORK_LABELS:Readonly<Record<ClinicalTodayStatus,string>>={done:'Done today',started:'Started, not finished',not_today:'Not today'};
export function latestTodayFacts(value:ClinicalTodayWorkView|null|undefined):ClinicalTodayWorkFact[] {
 if(!value?.available)return [];
 const latest=new Map<number,ClinicalTodayWorkFact>();
 for(const row of value.facts){
  if(row.caseSheetId!==value.caseSheetId)throw Error('The saved work belongs to another visit.');
  const prior=latest.get(row.planItemId);
  if(!prior||row.revision>prior.revision)latest.set(row.planItemId,row);
 }
 return [...latest.values()];
}
/** Qualitative facts do not enter completion, pricing, payment or outcome derivations. */
export function savedTodayFact(value:ClinicalTodayWorkView|null|undefined,itemId:number){return latestTodayFacts(value).find(row=>row.planItemId===itemId)??null;}
